import { Reveal, Eyebrow } from "../Reveal";
import { RETAIL_AREAS, IMAGES } from "../../lib/data";

const RetailFocus = () => (
  <section data-testid="retail-focus-section" className="relative overflow-hidden border-t border-black/10">
    <div className="mx-auto max-w-7xl px-5 py-20 lg:px-8 lg:py-32">
      <div className="grid items-center gap-14 lg:grid-cols-2 lg:gap-20">
        <Reveal className="relative order-2 lg:order-1">
          <div className="absolute -inset-10 -z-10 rounded-full bg-ember/15 blur-3xl" aria-hidden="true" />
          <img
            src={IMAGES.fuelPump.url}
            alt={IMAGES.fuelPump.alt}
            loading="lazy"
            className="aspect-[4/5] w-full object-cover"
          />
          <div className="absolute -bottom-4 -right-4 h-full w-full border border-ember/40" aria-hidden="true" />
        </Reveal>

        <Reveal delay={0.1} className="order-1 lg:order-2">
          <Eyebrow>Petroleum Retail Services</Eyebrow>
          <h2 className="font-display text-3xl font-extrabold leading-tight tracking-tight sm:text-4xl lg:text-5xl">
            Keeping Petroleum Retail Locations Operating
          </h2>
          <p className="mt-6 text-base leading-relaxed text-mist md:text-lg">
            A gas station combines retail, commercial, mechanical, electrical, forecourt and
            customer-facing environments in a single property. Each part wears, ages and
            occasionally fails — and each part affects how customers experience your business.
          </p>
          <p className="mt-4 text-base leading-relaxed text-mist md:text-lg">
            Petroline Services helps operators address maintenance and improvement needs through
            one coordinated commercial service provider.
          </p>

          <div className="mt-10 grid grid-cols-2 gap-px border border-black/10 bg-black/10 sm:grid-cols-3">
            {RETAIL_AREAS.map((area) => (
              <div
                key={area.label}
                data-testid={`retail-area-${area.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="flex flex-col items-start gap-3 bg-white p-5"
              >
                <area.icon className="h-6 w-6 text-ember" />
                <span className="text-xs font-bold uppercase tracking-[0.15em] text-neutral-600">
                  {area.label}
                </span>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

export default RetailFocus;
